var makeDirection = function (_a) {
    var column = _a.column, columnReverse = _a.columnReverse, rowReverse = _a.rowReverse;
    return column || columnReverse ? "bottom" : rowReverse ? "left" : "right";
};
export default (function (_a) {
    var baseUnit = _a.theme.constants.SIZE_SUB_UNIT, gap = _a.gap, column = _a.column, columnReverse = _a.columnReverse, rowReverse = _a.rowReverse;
    if (typeof gap !== "number") {
        return "";
    }
    var direction = makeDirection({ column: column, columnReverse: columnReverse, rowReverse: rowReverse });
    return "\n    &> *:not(:last-child) {\n      margin-".concat(direction, ": ").concat(baseUnit * gap, "px;\n    }\n  ");
});
